'use strict';

exports.__esModule = true;
exports.default = NoSandboxError;
function NoSandboxError(message) {
  this.name = 'NoSandboxError';
  this.message = message || 'Perimeter must be imported into a sandbox.';
}

NoSandboxError.prototype = Error.prototype;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/errors/NoSandboxError.js
// module id = pyv9
// module chunks = 0